import { Templates } from './Templates.js';

export class RowExpander extends HTMLElement {
	static observedAttributes=['child-count','loading'];
	constructor() {
		super();
		[this.el, this.$] = Templates('RowExpander');
		this.attachShadow({mode:'open'});
		this.shadowRoot.appendChild(this.el);
	}
	connectedCallback() {

	}
	attributeChangedCallback(name, oldValue, newValue) {

	}
}
customElements.define('safire-rowexpander', RowExpander);